export default __webpack_public_path__ + "static/media/Zee News.dff50447.svg";